import { useCallback, useEffect, useState } from 'react'
import AmicaleApi from '../../../api/AmicaleApi'

const EMPTY = {
  loading: true,
  granted: [],
  hasCarteAcces: false,
  hasBienEtre: false,
  showTabs: false,
}

const useAmicaleCartesAccess = (enabled = true) => {
  const [state, setState] = useState(EMPTY)

  const refresh = useCallback(async () => {
    if (!enabled) {
      setState({ ...EMPTY, loading: false })
      return
    }
    setState((prev) => ({ ...prev, loading: true }))
    try {
      const data = await AmicaleApi.getMoteurCartesAccess()
      setState({
        loading: false,
        granted: data?.granted || [],
        hasCarteAcces: Boolean(data?.hasCarteAcces),
        hasBienEtre: Boolean(data?.hasBienEtre),
        showTabs: Boolean(data?.hasCarteAcces || data?.hasBienEtre),
      })
    } catch {
      setState({ ...EMPTY, loading: false })
    }
  }, [enabled])

  useEffect(() => {
    refresh()
  }, [refresh])

  return { ...state, refresh }
}

export default useAmicaleCartesAccess
